export default "__VITE_ASSET__DnHbdFUF__"